import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Calculator from "@/components/Calculator";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Calculator />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;